import { IPublishDraftJobPostPayload } from '../types';
import { PermanentJobsApi } from '../clients';

export const publishDraftJobPost = async (
  id: string,
  payload: IPublishDraftJobPostPayload,
): Promise<void> => {
  await PermanentJobsApi.publishDraftJobPost(id, payload);
};
